import { useEffect } from "react";
import { Space } from "antd";
import SuccessfulPaymentsTable from "../../../../components/specific/payments/successfulPaymentsTable";
import FailedPaymentsTable from "../../../../components/specific/payments/failedPaymentsTable";
import HeaderBox from "../../../../components/generic/arpariBoxes/headerBox";


function Receipts(props) {
  useEffect(() => {

  }, [props]);

  return (
    <Space direction="vertical">
      <HeaderBox
        title="Successful Payments"
        ignoreDocumentTitle={true}
      />
      <SuccessfulPaymentsTable
        paymentsData={props.successfulPayments}
        loading={false}
      />
      <HeaderBox
        title="Failed Payments"
        ignoreDocumentTitle={true}
      />
      <FailedPaymentsTable
        paymentsData={props.failedPayments}
        loading={false}
      />
    </Space>
  );
}

export default Receipts;
